import { TEAM_CATEGORIES, type TEAM_CATEGORY } from 'cpool-constants';
import { LuFileChartColumn, LuHeadset, LuLandmark } from 'react-icons/lu';

const ICONS = {
    [TEAM_CATEGORIES.MARKT]: LuHeadset,
    [TEAM_CATEGORIES.MARKTFOLGE_BANK]: LuLandmark,
    [TEAM_CATEGORIES.MARKTFOLGE_UNTERLAGENBESCHAFFUNG]: LuFileChartColumn,
} satisfies Record<TEAM_CATEGORY, unknown>;

type Props = { category: TEAM_CATEGORY | null };

export const TeamCategoryIcon: React.FC<Props> = ({ category }) => {
    if (!category) return null;
    const Icon = ICONS[category];
    return <Icon aria-hidden className="size-4 shrink-0" data-testid={`team-category-icon-${category}`} />;
};
